module.exports = __webpack_public_path__ + "feb50635786f30a046a36ff400a6e4fd.svg";